import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenericInlineItemListComponent } from './generic-inline-item-list.component';

@NgModule({
  declarations: [GenericInlineItemListComponent],
  imports: [CommonModule],
  exports: [GenericInlineItemListComponent],
})
export class GenericInlineItemListModule {}
